/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-09-22 09:59:26
 * @LastEditors: linxi
 * @LastEditTime: 2022-09-28 14:39:48
 */

import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Popconfirm,
  Row,
  Select,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  setAppShadeIsModal,
  setAppShadeTipText,
} from '../../layouts/layoutSlice'
import styles from './Tenants.module.css'
import {
  getCopyDirectoryReplicationSubmit,
  getCopyDirectoryReplicationSubmitSecond,
  getDirectoryReplicationDetail,
  getDirectoryReplicationDetailSecond,
  getLabelList,
  getTenantList,
} from './tenantSlice'

export const DirectoryReplicationModal = (props: {
  visible: boolean
  id?: any
  tenantIds?: any
  num?: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [checkedList, setCheckedList] = useState<any>()

  const [organizationList, setOrganizationList] = useState<any>([]) //数据

  const [selectMaterialsList, setSelectMaterialsList] = useState<any>([])

  const [selectTreatmentList, setSelectTreatmentList] = useState<any>([])

  const [sumCount, setSumCount] = useState<number>(0)

  const [allData, setAllData] = useState<any>()

  useEffect(() => { 
    const sumMaterials = selectMaterialsList
    ?.map((s: any) => allData?.materialsList?.find((m: any) => s == m?.billingCategory))
    .reduce((n: number, v: any) => n + v?.billingCategoryNum, 0)

    const sumTreatment = selectTreatmentList
    ?.map((s: any) => allData?.treatmentList?.find((m: any) => s == m?.treatmentCategoryName))
    .reduce((n: number, v: any) => n + v?.treatmentCategoryNum, 0)
    
    setSumCount(sumMaterials + sumTreatment)
  }, [selectMaterialsList, selectTreatmentList])

  useEffect(() => {
    if (props?.visible) {
      getOptions('')
    } else {
      setAllData({
        treatmentList: [],
        materialsList: [],
      })
    }
  }, [props?.visible])

  const getOptions = (params = '') => {
    dispatch(
      getTenantList({
        current: 1,
        size: 500,
        name: params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setOrganizationList(res?.items)
      })
  }




  return (
    <Modal
      footer={null}
      className={styles.directoryReplicationModal}
      width={800}
      title='目录复制'
      visible={props.visible}
      onOk={() => {
        props.onOk()
        form.resetFields()
      }}
      onCancel={() => {
        props.onCancel()
        form.resetFields()
      }}
    >
      <Form
        // {...layout}
        autoComplete='off'
        form={form}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 19,
        }}
        onFinish={(fs) => {
          dispatch(setAppShadeIsModal(true))
          dispatch(setAppShadeTipText('正在处理中，请稍后~~~'))
          dispatch(
            getCopyDirectoryReplicationSubmitSecond({
              tenantId: fs?.tenantIdList,
              tenantIds: props?.tenantIds,
              templateIds: fs?.templateIds,
              materialsList: fs?.materialsList,
              treatmentList: fs?.treatmentList,
            })
          )
            .then(unwrapResult)
            .then((res: any) => {
              console.log(res);
              
              dispatch(setAppShadeIsModal(false))
              dispatch(setAppShadeTipText('请稍后~~~'))
              notification.success({
                message: res || '操作成功',
                duration: 3,
              })
              props.onOk()
              form.resetFields()
            })
            .catch((error) => {
              dispatch(setAppShadeIsModal(false))
              dispatch(setAppShadeTipText('请稍后~~~'))
              notification.error({
                message: '操作失败',
                duration: 3,
              })
              props.onCancel()
              form.resetFields()
            })
        }}
      >
        <Row style={{ margin: '20px 0 0 25px' }}>
          <Col span={24}>
            <Form.Item
              label='选择一家被复制的机构'
              name='tenantIdList'
              rules={[
                {
                  required: true,
                  max: 500,
                  message: '请选择机构！',
                },
              ]}
            >
              <Select
                style={{ width: '300px' }}
                placeholder='请输入机构名称以检索'
                allowClear
                showSearch
                onChange={(v: any) => {
                  if (v)
                    dispatch(getDirectoryReplicationDetailSecond({ tenantId: v }))
                      .then(unwrapResult)
                      .then((res: any) => {
                        setAllData(res)
                      })
                }}
                filterOption={false}
                onSearch={(res: string) => {
                  setAllData({
                    treatmentList: [],
                    materialsList: [],
                  })
                  setCheckedList([])
                  getOptions(res)
                }}
              >
                {organizationList?.map((a: any, i: number) => (
                  <Select.Option key={i} value={a?.id}>
                    {a?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {allData?.treatmentList?.length == 0 && allData?.materialsList?.length == 0 ? (
            <Col span={24}>
              <p>该机构没有任何目录</p>
            </Col>
          ) : (
            <>
              <Col span={24}>
                <Form.Item
                  label='诊疗目录'
                  name='treatmentList'
                >
                  <Select
                    style={{ width: '300px' }}
                    placeholder='请选择诊疗目录'
                    allowClear
                    mode="multiple"
                    onChange={((v) => {
                      setSelectTreatmentList(v)
                    })}
                  >
                    {allData?.treatmentList?.map((a: any, i: number) => (
                      <Select.Option key={a?.treatmentCategoryName} value={a?.treatmentCategoryName}>
                        {a?.treatmentCategoryName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label='药品目录'
                  name='materialsList'
                >
                  <Select
                    style={{ width: '300px' }}
                    placeholder='请选择药品目录'
                    allowClear
                    mode="multiple"
                    onChange={((v) => {
                      setSelectMaterialsList(v)
                    })}
                  >
                    {allData?.materialsList?.map((a: any, i: number) => (
                      <Select.Option key={a?.billingCategory} value={a?.billingCategory}>
                        {a?.billingCategoryName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </>
          )}
        </Row>
        <Row
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            margin: '20px 0px 0 0 ',
            paddingTop: '15px',
            borderTop: '1px solid #f0f0f0',
          }}
        >
          <div
            style={{
              height: '50px',
              marginRight: '10px',
            }}
          >
            <Button
              onClick={() => {
                props.onCancel()
                form.resetFields()
              }}
            >
              取消
            </Button>
          </div>
          <div
            style={{
              height: '50px',
              marginRight: '10px',
            }}
          >
            <Popconfirm
              placement='topRight'
              title={
                '本次操作将会给选中的' +
                `${props?.num}` +
                '家机构新增' +
                `${sumCount}` +
                '条目录，请确认！'
              }
              onConfirm={() => {
                form.submit()
              }}
              okText='确认'
              cancelText='取消'
            >
              <Button type='primary'>
                确认
              </Button>
            </Popconfirm>
          </div>
        </Row>
      </Form>
    </Modal>
  )
}
